import React, { createContext, useContext, useMemo, useState, useCallback } from "react";
import es from "@/i18n/es.json";
import en from "@/i18n/en.json";

const DICTS = { es, en };
const I18nContext = createContext(null);

function resolve(dict, key) {
  return key.split(".").reduce((acc, part) => (acc == null ? undefined : acc[part]), dict);
}

// Fix T (2026-10-05): si falta una traducción se avisa en la consola (una vez por clave) y
// se muestra la última parte de la clave en texto legible, nunca «messages.events.x».
const clavesAvisadas = new Set();
function textoDeRespaldo(key) {
  if (!clavesAvisadas.has(key)) {
    clavesAvisadas.add(key);
    console.warn(`[i18n] falta la traducción de «${key}»`);
  }
  const ultima = String(key).split(".").pop().replace(/_/g, " ").trim();
  return ultima ? ultima.charAt(0).toUpperCase() + ultima.slice(1) : String(key);
}

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(localStorage.getItem("bh_lang") || "es");

  const changeLang = useCallback((next) => {
    localStorage.setItem("bh_lang", next);
    setLang(next);
  }, []);

  const t = useCallback(
    (key, vars) => {
      let value = resolve(DICTS[lang], key);
      if (typeof value !== "string") value = resolve(DICTS.es, key);
      if (typeof value !== "string") value = resolve(DICTS.en, key);
      if (typeof value !== "string") return textoDeRespaldo(key);
      if (typeof value === "string" && vars) {
        Object.entries(vars).forEach(([k, v]) => {
          value = value.replace(new RegExp(`{${k}}`, "g"), v);
        });
      }
      return value;
    },
    [lang]
  );

  const value = useMemo(() => ({ t, lang, setLang: changeLang }), [t, lang, changeLang]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useT = () => {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useT debe usarse dentro de I18nProvider");
  return ctx;
};
